function clamp(min, values, max) {
  if (Array.isArray(values)) {
    return Math.min(max, Math.max(...values, min));
  } else {
    return Math.min(max, Math.max(values, min));
  }
}

export { clamp };
//# sourceMappingURL=clamp.js.map
